import React from 'react';
import { Tooltip, Badge, Box } from '@mui/material';
import { OutlinedIcons } from '@marageti/z4-lib';

interface InfoTooltipProps {
  tooltipText: string;
  placement?: 'top' | 'bottom' | 'left' | 'right';
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({
  tooltipText,
  placement = 'top',
}) => (
  <Box
    sx={{
      width: 21,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Tooltip
      title={tooltipText}
      disableFocusListener
      enterTouchDelay={0}
      placement={placement}
    >
      <Badge
        badgeContent={<OutlinedIcons.OutlinedInformationCircleIcon fontSize="small" />}
        sx={{
          color: '#4A5152',
          display: 'flex',
          '& .MuiBadge-badge': {
            position: 'static',
            transform: 'none',
          },
        }}
      />
    </Tooltip>
  </Box>
);

export default InfoTooltip;
